import { Setpoint } from 'journeys/portal/Forms/Sections.constants';
import {
    setpointNote, highHighSetpointValue, highSetpointValue, lowSetpointValue, lowLowSetpointValue, highHighSetpointComment, lowSetpointComment,
    lowLowSetpointComment, highSetPointComment, highHighSetpointCommentValue, highSetpointCommentValue, lowLowSetpointCommentValue, lowSetpointCommentValue,
    borderBottomHHDisable, borderBottomDisable, borderBottomLDisable
} from '../C11/C11.data';
import { labelWidth, paddingLabel, paddingLabelComment, height } from '../S72/S72.data';
import { generateUnitLabel } from '../../../AsFoundTestTableSection/Data/P734/P734.data';

export const SetpointSectionDataP734 = (selectedTag, formName, formData) => ({
        rows: [
            {
                key: 1,
                fields: [{
                    key: 'remark',
                    label: setpointNote,
                    isLabel: true,
                    xs: 12,
                    fontWeight: '600',
                    labelWidth: '99%',
                    padding: '5px 1px 10px 3px',
                    fontSize: '8.5pt',
                    color: '#ea7c34',
                    marginTop: '0'
                }]
            },
            {
                key: 2,
                fields: [
                    {
                        key: 'F240HighHighSetpointLabel',
                        label: `${generateUnitLabel(Setpoint.HIGH_HIGH_SETPOINT, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        padding: paddingLabel
                    },
                    {
                        key: 'F240HighHighSetpoint',
                        value: highHighSetpointValue(selectedTag, formData),
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderBottom: borderBottomHHDisable(selectedTag, formData)
                    },
                    {
                        key: 'F51HmiReading1Label',
                        label: `${generateUnitLabel(Setpoint.HMI_READING, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel
                    },
                    {
                        key: 'F51HmiReading1',
                        value: formData.F51HmiReading1,
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderBottom: borderBottomHHDisable(selectedTag, formData)
                    },
                    {
                        key: 'F1069SystemReading1Label',
                        label: `${generateUnitLabel(Setpoint.SYSTEM_READING, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel
                    },
                    {
                        key: 'F1069SystemReading1',
                        value: formData.F1069SystemReading1,
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderRight: '0',
                        borderBottom: borderBottomHHDisable(selectedTag, formData)
                    }]
            },
            highHighSetpointComment(selectedTag, formData) ? {
                key: 3,
                fields: [
                    {
                        key: 'F448HighHighSetpointCommentLabel',
                        label: Setpoint.HIGH_HIGH_SETPOINT_COMMENT,
                        xs: 2,
                        textAlign: 'left',
                        fontStyle: 'italic',
                        padding: paddingLabelComment,
                        isLabel: 'true',
                        labelWidth,
                        fontSize: '9pt',
                        fontWeight: '600'
                    },
                    {
                        key: 'F448HighHighSetpointComment',
                        value: highHighSetpointCommentValue(selectedTag, formData),
                        textAlign: 'center',
                        fontStyle: 'italic',
                        isInfo: true,
                        wordBreak: false,
                        width: '100%',
                        height: '1.4rem',
                        padding: paddingLabelComment,
                        labelWidth: '0%',
                        noWrap: true
                    }]
            } : {
                key: 3,
                fields: []
            },
            {
                key: 4,
                fields: [
                    {
                        key: 'F32HighSetpointLabel',
                        label: `${generateUnitLabel(Setpoint.HIGH_SETPOINT, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        padding: paddingLabel
                    },
                    {
                        key: 'F32HighSetpoint',
                        value: highSetpointValue(selectedTag, formData),
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderBottom: borderBottomDisable(selectedTag, formData)
                    },
                    {
                        key: 'F52HmiReading2Label',
                        label: `${generateUnitLabel(Setpoint.HMI_READING, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel
                    },
                    {
                        key: 'F52HmiReading2',
                        value: formData.F52HmiReading2,
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderBottom: borderBottomDisable(selectedTag, formData)
                    },
                    {
                        key: 'F1070SystemReading2Label',
                        label: `${generateUnitLabel(Setpoint.SYSTEM_READING, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel
                    },
                    {
                        key: 'F1070SystemReading2',
                        value: formData.F1070SystemReading2,
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderRight: '0',
                        borderBottom: borderBottomDisable(selectedTag, formData)
                    }]
            },
            highSetPointComment(selectedTag, formData) ? {
                key: 5,
                fields: [
                    {
                        key: 'F796HighSetpointCommentLabel',
                        label: Setpoint.HIGH_SETPOINT_COMMENT,
                        xs: 2,
                        textAlign: 'left',
                        fontStyle: 'italic',
                        padding: paddingLabelComment,
                        isLabel: 'true',
                        labelWidth,
                        fontSize: '9pt',
                        fontWeight: '600'
                    },
                    {
                        key: 'F796HighSetpointComment',
                        value: highSetpointCommentValue(selectedTag, formData),
                        textAlign: 'center',
                        fontStyle: 'italic',
                        isInfo: true,
                        wordBreak: false,
                        width: '100%',
                        height: '1.4rem',
                        padding: paddingLabelComment,
                        labelWidth: '0%',
                        noWrap: true
                    }]
            } : {
                key: 5,
                fields: []
            },
            {
                key: 6,
                fields: [
                    {
                        key: 'F33LowSetpointLabel',
                        label: `${generateUnitLabel(Setpoint.LOW_SETPOINT, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        padding: paddingLabel
                    },
                    {
                        key: 'F33LowSetpoint',
                        value: lowSetpointValue(selectedTag, formData),
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderBottom: borderBottomLDisable(selectedTag, formData)
                    },
                    {
                        key: 'F53HmiReading3Label',
                        label: `${generateUnitLabel(Setpoint.HMI_READING, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel
                    },
                    {
                        key: 'F53HmiReading3',
                        value: formData.F53HmiReading3,
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderBottom: borderBottomLDisable(selectedTag, formData)
                    },
                    {
                        key: 'F1071SystemReading3Label',
                        label: `${generateUnitLabel(Setpoint.SYSTEM_READING, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel
                    },
                    {
                        key: 'F1071SystemReading3',
                        value: formData.F1071SystemReading3,
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderRight: '0',
                        borderBottom: borderBottomLDisable(selectedTag, formData)
                    }]
            },
            lowSetpointComment(selectedTag, formData) ? {
                key: 7,
                fields: [
                    {
                        key: 'F797LowSetpointCommentLabel',
                        label: Setpoint.LOW_SETPOINT_COMMENT,
                        xs: 2,
                        textAlign: 'left',
                        fontStyle: 'italic',
                        padding: paddingLabelComment,
                        isLabel: 'true',
                        labelWidth,
                        fontSize: '9pt',
                        fontWeight: '600'
                    },
                    {
                        key: 'F797LowSetpointComment',
                        value: lowSetpointCommentValue(selectedTag, formData),
                        textAlign: 'center',
                        fontStyle: 'italic',
                        isInfo: true,
                        wordBreak: false,
                        width: '100%',
                        height: '1.4rem',
                        padding: paddingLabelComment,
                        labelWidth: '0%',
                        noWrap: true
                    }]
            } : {
                key: 7,
                fields: []
            },
            {
                key: 8,
                fields: [
                    {
                        key: 'F241LowLowSetpointLabel',
                        label: `${generateUnitLabel(Setpoint.LOW_LOW_SETPOINT, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        padding: paddingLabel
                    },
                    {
                        key: 'F241LowLowSetpoint',
                        value: lowLowSetpointValue(selectedTag, formData),
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderTop: !lowSetpointComment(selectedTag, formData),
                        borderBottom: lowLowSetpointComment(selectedTag, formData) ? '' : 0,
                        marginBottom: lowLowSetpointComment(selectedTag, formData) ? '' : '4px',
                    },
                    {
                        key: 'F54HmiReading4Label',
                        label: `${generateUnitLabel(Setpoint.HMI_READING, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel
                    },
                    {
                        key: 'F54HmiReading4',
                        value: formData.F54HmiReading4,
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderTop: !lowSetpointComment(selectedTag, formData),
                        borderBottom: lowLowSetpointComment(selectedTag, formData) ? '' : 0,
                        marginBottom: lowLowSetpointComment(selectedTag, formData) ? '' : '4px',
                    },
                    {
                        key: 'F1072SystemReading4Label',
                        label: `${generateUnitLabel(Setpoint.SYSTEM_READING, formData)}`,
                        xs: 2,
                        isLabel: true,
                        labelWidth,
                        fontWeight: '600',
                        fontSize: '9pt',
                        textAlign: 'right',
                        padding: paddingLabel
                    },
                    {
                        key: 'F1072SystemReading4',
                        value: formData.F1072SystemReading4,
                        xs: 2,
                        type: 'number',
                        maxLength: '10',
                        labelWidth: '0%',
                        width: '100%',
                        height,
                        textAlign: 'center',
                        borderRight: '0',
                        borderTop: !lowSetpointComment(selectedTag, formData),
                        borderBottom: lowLowSetpointComment(selectedTag, formData) ? '' : 0,
                        marginBottom: lowLowSetpointComment(selectedTag, formData) ? '' : '4px',
                    }]
            },
            lowLowSetpointComment(selectedTag, formData) ? {
                key: 9,
                fields: [
                    {
                        key: 'F449LowLowSetpointCommentLabel',
                        label: Setpoint.LOW_LOW_SETPOINT_COMMENT,
                        xs: 2,
                        textAlign: 'left',
                        fontStyle: 'italic',
                        padding: '5px 0 3px 3px',
                        isLabel: 'true',
                        labelWidth,
                        fontSize: '9pt',
                        fontWeight: '600'
                    },
                    {
                        key: 'F449LowLowSetpointComment',
                        value: lowLowSetpointCommentValue(selectedTag, formData),
                        textAlign: 'center',
                        fontStyle: 'italic',
                        isInfo: true,
                        wordBreak: false,
                        width: '100%',
                        height: '1.4rem',
                        padding: '5px 0 3px 3px',
                        labelWidth: '0%',
                        noWrap: true
                    }]
            } : {
                key: 9,
                fields: []
            }
        ]
    });
